import React, { useState } from 'react';
import { T, TraksConsumer } from '../../traks';
import { RenderIf } from '../../helpers/RenderIf';
import { Messages } from '../../c/Messages';
import { WhistleContent } from '../../c/Whistle';
import { Col, Modal, Row } from 'reactstrap';
import { CollapsibleContainer } from '../../c/CollapsibleContainer';
import { ConfirmModal } from '../../c/Modals';
import UploadAndDownload from '../../c/UploadAndDownload';
import Logs from '../../c/logs';
import WhistleInfo from '../Dashboard/Whistle/WhistleInfo';
import WhistleAudioContent from "../../c/Whistle/AudioContent"


const WhistleModals = ({ whistle, confirmationModal, setConfirmationModal, handleDeleteWhistle }) => {
	const [showLogs, setShowLogs] = useState(false)

	return (
		<RenderIf condition={whistle.status !== "deleted" && whistle.whistle_owner}>
			<div className="mb-1 mb-sm-3 d-flex justify-content-between justify-content-sm-end ">
				<div className="d-flex me-md-4">
					<button onClick={() => setShowLogs(!showLogs)} className="btn sibilus_border hoverable-white">
						{!showLogs ? <T>show logs</T> : <T>hide logs</T>}
					</button>
					<RenderIf condition={showLogs} >
						<Modal isOpen={showLogs} toggle={() => setShowLogs(false)} className={"modals"}>
							<div className="p-5">
								<Logs
									whistle={whistle}
								/>
							</div>
						</Modal>
					</RenderIf>
					<div>
						<span data-cy="deleteWhistle" className="btn" onClick={() => handleDeleteWhistle()}>
							<img alt="delete" src="https://static.sibilus.eu/gfx/delete-icon-0.svg" className="mx-2" style={{ marginTop: '-6px' }} />
							<T>Delete Entry</T>
						</span>
					</div>
					<RenderIf condition={confirmationModal}>
						<TraksConsumer>
							<DeleteModal
								isShowing={confirmationModal}
								hide={() => setConfirmationModal(false)}
								onConfirm={handleDeleteWhistle}
							/>
						</TraksConsumer>
					</RenderIf>
				</div>
			</div>
		</RenderIf>
	)
}

const DeleteModal = ({ isShowing, hide, onConfirm, ...props }) => {
	const confirmText = {
		header: props.render_static(<T>Delete Entry</T>),
		body: props.render_static(<T>Are you sure you want to delete all content of the entry? This action cannot be undone.</T>)
	}
	return (
		<ConfirmModal
			header={confirmText.header}
			body={confirmText.body}
			isShowing={isShowing}
			hide={hide}
			onConfirm={onConfirm}
		/>
	)
}

const getScreenName = (whistle) => {
	if (whistle) {
		const agent = (whistle.access.find(el => el.access_id === whistle.whistle_access_id))
		return agent["screen_name"]
	}
	return ""
}

const Whistle = ({
	whistle,
	deleteMessage,
	messages,
	setMessages,
	audioContentUrl,
	confirmationModal,
	setConfirmationModal,
	handleDeleteWhistle,
	files,
	setFiles,
	getWhistle
}) => {
	return (
		<Row className="justify-content-center mx-0 mx-xl-5 mt-5">
			<WhistleModals
				confirmationModal={confirmationModal}
				setConfirmationModal={setConfirmationModal}
				whistle={whistle}
				handleDeleteWhistle={handleDeleteWhistle}
			/>
			<Col xs={12} lg={8}>
				<div >
					<RenderIf condition={whistle.access[0].type !== "link"}>
						<div className="mb-5">
							<WhistleInfo
								whistle={whistle}
							/>
						</div>
					</RenderIf>
					<RenderIf condition={whistle.content}>
						<CollapsibleContainer>
							<div className="fw_700">
								<T>Entry</T>
							</div>
							<div>
								<WhistleContent
									content={whistle.content}
								/>
								<RenderIf condition={audioContentUrl !== undefined}>
									<div className="my-5">
										<WhistleAudioContent
											audioContentURL={audioContentUrl}
										/>
									</div>
								</RenderIf>
							</div>
						</CollapsibleContainer>
					</RenderIf >
				</div >
				<div className="my-5">
					<Messages
						messages={messages}
						whistle={whistle}
						setMessages={setMessages}
						deleteMessage={deleteMessage}
						showMessageChoice={!whistle.whistle_owner}
					/>
				</div>
			</Col >
			<RenderIf condition={whistle && whistle["status"] !== "deleted"}>
				<Col md={12} lg={4}>
					<div className="mb-lg-0 mb-5">
						<UploadAndDownload
							setFiles={setFiles}
							files={files}
							screenName={getScreenName(whistle)}
							updateWhistle={getWhistle}
							whistle={whistle}
						/>
					</div>
				</Col>
			</RenderIf>
		</Row >)
}

export default Whistle;
